import { useResponseStatus } from '../../hooks/useResponseStatus'
import { axiosInstanceBearer } from './axiosInstance'

export async function delApiData<Response>(url: string, data: Object = {}) {
  return await axiosInstanceBearer()
    .delete<Response>(url, data)
    .then((response) => {
      return {
        data: response,
        error: '',
      }
    })
    .catch((error) => {
      useResponseStatus(error.response.status)
      return {
        error: error.response?.data,
      }
    })
}
